<template>
  <div class>
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
          <ion-buttons v-slot: start>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title class="fontRoboto">Select EV</ion-title>
              <ion-icon :icon="homeSharp" class="ion-margin ios" @click="homePage"></ion-icon>
          </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar class="header-toolbar">
        <ion-grid class="title-wrapper ion-no-padding">
          <ion-row>
            <ion-col size-md="8">
              <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons v-slot: start>
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                </ion-buttons>
                <ion-title class="fontRoboto">New Reservation / Select EV</ion-title>
              </ion-toolbar>
            </ion-col>
            <ion-col size-md="4" size-xs="8" class="ion-no-padding">
              <div class="price-tag">
                <p class="ion-no-margin">Available Bal</p>
                <p class="ion-no-margin">&#8377; {{this.amountDetails.clearBalance}}</p>
              </div>
              <div class="price-tag">
                <p class="ion-no-margin">Current Bal</p>
                <p class="ion-no-margin">&#8377; {{this.amountDetails.totalBalance}}</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </ion-header>
    <ion-content class="vehicle-page">
      <ion-grid class="sv-paddingZero" v-if="vehicles && vehicles.length > 0">
        <ion-row class="vechileList-wrapper">
          <ion-col
            size-md="12"
            size-sm="12"
            size-xs="12"
            size-lg="12"
            size-xl="4"
            @click="slotBooking(vehicle)"
            class="vechileList-sec"
            v-for="(vehicle, index) in vehicles"
            :key="index"
          >
            <ion-row>
              <ion-col size-md="8" size-xs="10">
                <span class="ion-no-margin">
                  <img
                    v-if="vehicle.type.id === 'TW'"
                    class="sv-icon"
                    src="/assets/images/vehicles/335024.png"
                  />
                  <img
                    v-if="vehicle.type.id == 'FW'"
                    class="sv-icon"
                    src="/assets/images/vehicles/846338.png"
                  />
                  <img
                    v-if="vehicle.type.id == '3W'"
                    class="sv-icon"
                    src="/assets/images/vehicles/rickshaw.png"
                  />
                  <img
                    v-if="vehicle.type.id == 'BUS'"
                    class="sv-icon"
                    src="/assets/images/vehicles/bus.png"
                  />
                  <img
                    v-if="vehicle.type.id == 'TRUCK'"
                    class="sv-icon"
                    src="/assets/images/vehicles/truck.png"
                  />
                </span>
                <span class="sv-num fontRobotoMedium">{{vehicle.regNo}}</span>
                <p
                class="ion-no-margin sv-model fontRoboto"
                >{{vehicle.make.name}}&nbsp;{{vehicle.model.name}}</p>
                <p class="ion-no-margin sv-type fontRobotoLight">{{vehicle.socketType.name}}</p>
              </ion-col>
              <ion-col size-md="4" size-xs="2">
                <p
                class="ion-no-margin sv-year textAlignRight fontRobotoLight"
                >{{vehicle.yearOfManufacturing}}</p>
                <ion-checkbox class="sv-checkbox textAlignRight"></ion-checkbox>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div class="spinnerWrapper">
        <ion-spinner v-if="loaderTab"></ion-spinner>
      </div>
      
      <ion-fab vertical="bottom" horizontal="end" v-slot: fixed>
        <ion-fab-button class="fab-primary chargeNowFab">
          Add Evs
          <!-- <ion-icon :icon="add"></ion-icon> -->
        </ion-fab-button>
        <ion-fab-list side="top">
          <div class="fab-btn-grp">
            <p
            class="ion-no-margin fab-btn-rv fontRobotoMedium"
            @click="addVehicle('R')"
            >Registered Vehicle</p>
            <p
            class="ion-no-margin fab-btn-uv fontRobotoMedium"
            @click="addVehicle('U')"
            >Unregistered Vehicle</p>
          </div>
        </ion-fab-list>
      </ion-fab>
    </ion-content>
  </div>
</template>

<script>
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonFab, IonFabList, IonFabButton, IonIcon, IonSpinner, IonGrid, IonRow, IonCol, IonCheckbox } from "@ionic/vue";
import { defineComponent } from "vue";
import { add, homeSharp } from 'ionicons/icons';
import { VehicleService } from "../../service/vehicle/vehicle.service";
import { migratedTryParseServiceError } from "../../service";
import { LocalStorage } from "../../data/localstorage";
import { Vehicle } from "../../entity/vehicle/vehicle";
import { User } from "../../entity/authentication/user";
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent ({
  name: 'selectVehicle',
  components: {
    IonHeader, 
    IonToolbar, 
    IonButtons, 
    IonBackButton, 
    IonTitle, 
    IonContent, 
    IonFab, 
    IonFabList, 
    IonFabButton, 
    IonIcon, 
    IonSpinner, 
    IonGrid, 
    IonRow, 
    IonCol, 
    IonCheckbox
  },
  data() {
    return {
      homeSharp,
      add,
      vehicles: null,
      amountDetails: {
        totalBalance: "",
        clearBalance: ""
      },
      loaderTab: true
    }
  },
  async mounted() {
    try {
      localStorage.removeItem("previousPath");
      localStorage.removeItem("vehiclePath");
      localStorage.removeItem("duration");
      localStorage.removeItem("slotDetails");
      this.amountDetails = JSON.parse(localStorage.getItem("amountDetails"));
      let user = new LocalStorage().user;
      this.vehicles = await new VehicleService().vehiclesOfUser(user);
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    homePage() {
      let userRole = localStorage.getItem("user.roleId")
      if(userRole == 2) {
        this.$router.push("/customer/reservation")
      }
    },
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    addVehicle(type) {
      localStorage.setItem("vehiclePath", "true");
      this.$router.push({
        name: "eVehicleNew",
        params: { vehicleType: type }
      });
    },
    viewVehicle(vehicleId) {
      this.$router.push({
        name: "eVehicleView",
        params: { vehicleId: vehicleId }
      });
    },
    slotBooking(vehicle) {
      try {
        localStorage.setItem("vehicle", JSON.stringify(vehicle));
        let chargeNow = localStorage.getItem("chargeNow");
        if(chargeNow != 'true') {
          this.$router.push({ name: "slotBookingForreservation" });
        } else {
          this.$router.push({ name: "slotBooking" });
        }
        // this.$router.push({ name: "slotBooking" });
      }catch (error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    }
  }
})
</script>


<style scoped>
ion-fab-button {
  padding-bottom: 50px;
}
.ios ion-icon {
  color: white;
  position: relative;
  left:70%;
}
ion-content {
  --background: #f4f5f9;
  position: absolute;
  --padding-bottom: 108px;
  --padding-top: 54px;
}

/* Title */
@media (max-width: 768px) {
  .vehicle-page {
    /* Status bar height on iOS 11.0 */
    top: constant(safe-area-inset-top);
    /* Status bar height on iOS 11+ */
    top: env(safe-area-inset-top);
  }

  .title-add-wrapper .add-wrapper .loc-img {
    margin-right: 13px !important;
  }

  .header-toolbar,
  .mobile-header-toolbar {
    --background: #21b24b;
  }

  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }

  .mobile-header-toolbar ion-title {
    color: #fff;
  }

  .mobile-header-toolbar ion-buttons {
    color: #fff;
    --background: #fff;
  }

  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }

  .paddingRight {
    padding-right: 0px !important;
  }

  .sv-paddingZero {
    padding: 0px;
  }
}
.spinnerWrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media (min-width: 768px) {
  .title-wrapper .price-tag {
    float: right;
  }

  .title-wrapper .price-tag {
    display: inline-block;
    margin-right: 20px;
    padding-top: 5px;
    padding-bottom: 7px;
  }

  .title-wrapper .price-tag p:first-child,
  .title-wrapper .price-tag p:last-child,
  .title-wrapper ion-title {
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
  }

  .title-wrapper ion-title {
    padding-top: 10px;
  }
}

.vechileList-sec {
  height: 129px;
  border: 1px solid #0000001a;

  opacity: 1;
  padding: 22px 37px 22px 21px;
}

@media (min-width: 768px) {
  .vechileList-sec {
    margin: 14px;
    border-radius: 12px;
  }

  .vechileList-wrapper {
    padding: 4px 7px 6px 2px;
    margin-top: 12px;
    border: 1px solid #0000001a;
    min-height: unset;
    margin-top: 16px;
  }
}

.vechileList-wrapper {
  min-height: 169px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  position: relative;
}

.sv-icon {
  width: 33px;
  height: 18px;
}

.sv-num,
.sv-model,
.sv-type,
.sv-year {
  color: #313131;
  font-size: 15px;
}

.sv-num {
  position: relative;
  top: -4px;
  left: 7px;
}

.sv-model,
.sv-type,
.sv-year {
  opacity: 0.75;
  margin-top: 8px;
}

.fontRobotoBold {
  font-family: "Roboto Bold";
}

.fontRobotoMedium {
  font-family: "Roboto Medium";
}

.fontRobotoLight {
  font-family: "Roboto light";
}

.fontRoboto {
  font-family: "Roboto";
}

.textAlignRight {
  text-align: right;
}

.sv-checkbox {
  position: absolute;
  bottom: 0px;
  right: 0px;
  --border: 1px solid #707070;
  --border-radius: 50%;
  width: 30px;
  height: 30px;
  opacity: 0.5;
}

.fab-btn {
  width: 56px;
  height: 66px;
}

.fab-btn-grp {
  width: 222px;
  min-height: 90px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #0000001a;
  border-radius: 8px;
  opacity: 1;
  padding-top: 16px;
  padding-left: 21px;
  position: absolute;
  padding-bottom: 17px;
  right: 0;
  bottom: 17px;
}

.fab-btn-rv,
.fab-btn-uv {
  color: #313131;
  opacity: 1;
  font-size: 14px;
  cursor: pointer;
}

.fab-btn-uv {
  margin-top: 23px;
}

/* Title */
</style>